// Grab wrapper nodes
var emblaNodes = document.querySelectorAll(".embla-product-gallery");

// Loop through all instances of embla
emblaNodes.forEach(function (emblaNode) {
  // Grab viewport node
  const viewportNode = emblaNode.querySelector(".embla__viewport");

  // Grab progress node
  const progressNode = emblaNode.querySelector(".embla__progress__bar");

  // Initialize the carousel
  const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

  // Add click listeners
  const { applyProgress, removeProgress } = setupProgressBar(
    emblaApi,
    progressNode
  );

  emblaApi
    .on("select", applyProgress)
    .on("init", applyProgress)
    .on("reInit", applyProgress)
    .on("scroll", applyProgress)
    .on("slideFocus", applyProgress)
    .on("destroy", removeProgress);
});
